module.exports = __webpack_public_path__ + "static/media/menu_1_20250506.b0a773bc.webp";